export const PLAYER_ADDED = 'PLAYER_ADDED'
export const PLAYER_CHANGED = 'PLAYER_CHANGED'
export const PLAYER_MOVED = 'PLAYER_MOVED'
export const PLAYER_REMOVED = 'PLAYER_REMOVED'
export const PLAYER_UPDATE = 'PLAYER_UPDATE'
